/**
 * Machine-readable error codes of the `ai-documentation` module (Spec § 9).
 * Carried in the `code` field of a 403/409 body so the UI can map them to
 * copy instead of parsing messages. Later slices append their own codes.
 */
export var AiDocumentationErrorCode;
(function (AiDocumentationErrorCode) {
    /** The practice has not confirmed the current Subprozessor-Hinweis. */
    AiDocumentationErrorCode["AI_DOCUMENTATION_NOT_ACTIVATED"] = "AI_DOCUMENTATION_NOT_ACTIVATED";
    /** The confirmed `textVersion` is not the current one — reload and re-read. */
    AiDocumentationErrorCode["NOTICE_VERSION_OUTDATED"] = "NOTICE_VERSION_OUTDATED";
    /** The practice already confirmed this version; the row is append-only. */
    AiDocumentationErrorCode["ACTIVATION_ALREADY_EXISTS"] = "ACTIVATION_ALREADY_EXISTS";
    /** Rule 3.2-1: the appointment is in the future, cancelled or a no-show (for the appointment or this patient). */
    AiDocumentationErrorCode["DICTATION_NOT_ALLOWED_FOR_APPOINTMENT"] = "DICTATION_NOT_ALLOWED_FOR_APPOINTMENT";
    /** Rule 3.2-2: another open dictation exists for this appointment and patient; the author may pass `replaceOpen`. */
    AiDocumentationErrorCode["OPEN_DICTATION_EXISTS"] = "OPEN_DICTATION_EXISTS";
    /**
     * A run is in progress: the newest draft (or transcript) of the dictation is
     * not `READY`, so there is nothing final to save or regenerate from yet.
     */
    AiDocumentationErrorCode["RUN_IN_PROGRESS"] = "RUN_IN_PROGRESS";
    /** The saved draft is not the newest one of its dictation — a regeneration replaced it. */
    AiDocumentationErrorCode["DRAFT_SUPERSEDED"] = "DRAFT_SUPERSEDED";
    /** The edited payload fails Schema v2 or `checkDraft` (Spec § 3.5); `violations` lists why. */
    AiDocumentationErrorCode["DRAFT_PAYLOAD_INVALID"] = "DRAFT_PAYLOAD_INVALID";
    /** Discard or save of a dictation whose draft already became a documentation item. */
    AiDocumentationErrorCode["DICTATION_ALREADY_SAVED"] = "DICTATION_ALREADY_SAVED";
    /** A `transcript` regeneration, but the audio is gone (saved, swept or deleted after a failure). */
    AiDocumentationErrorCode["AUDIO_NO_LONGER_AVAILABLE"] = "AUDIO_NO_LONGER_AVAILABLE";
    /**
     * Regeneration has no good artefact to start from: normalization failed
     * (discard and record again), or a `draft` regeneration after the
     * transcription failed (only `transcript` can recover that).
     */
    AiDocumentationErrorCode["NOTHING_TO_REGENERATE"] = "NOTHING_TO_REGENERATE";
})(AiDocumentationErrorCode || (AiDocumentationErrorCode = {}));
//# sourceMappingURL=ai-documentation-error-code.enum.js.map